var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"mb-6",attrs:{"outlined":""}},[_c('v-simple-table',{staticClass:"neu-glow"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Screen Size")]),_c('th',[_vm._v("Class")])])]),_c('tbody',_vm._l((_vm.classes),function(ref,i){
var text = ref[0];
var value = ref[1];
return _c('tr',{key:i},[_c('td',{domProps:{"textContent":_vm._s(text)}}),_c('td',[_c('code',{domProps:{"textContent":_vm._s(value)}})])])}),0)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }